import React, { useEffect, useState, useContext } from 'react';
import Sidebar from '../../../Sidebar/Sidebar';
import { UpdateVendorPayment, GetVendorPayment, PendingVendorInvoice, FileUpload } from '../../../../api';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import LoadingPage from '../../../LoadingPage/LoadingPage';
import { RiArrowGoBackFill } from 'react-icons/ri';
import { GlobalAlertInfo } from '../../../../App';
import Modal from '../../AlertModal/Modal';

function EditVendorPayments() {
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(true);
    const [data, setData] = useState([]);
    const [pendinginvoicelist, setPendinginvoicelist] = useState([]);
    const [filedata, setFiledata] = useState('');
    const [fileLoading, setFileLoading] = useState(false);
    const [fileUploadedSuccess, setFileUploadedSuccess] = useState(false);
    const [vendor, setVendor] = useState('');

    const { tooglevalue, callfun } = useContext(GlobalAlertInfo);

    useEffect(() => {
        const fetchdata = async () => {
            const org = localStorage.getItem('Database');
            const datas = await GetVendorPayment(org, localStorage.getItem('vendorpaymentssno'));
            setFiledata(datas[0].uploadpayment);
            setData(datas[0]);
            console.log("..................",datas)
            setVendor(datas[0].vendor || '');
            const invoice = await PendingVendorInvoice(org);
            setPendinginvoicelist(invoice);
            setLoading(true);
        };
        fetchdata();
    }, []);

    const handleAddVendorIvoice = async (e) => {
        e.preventDefault();
        setLoading(false);
        document.getElementById('subnitbtn').disabled = true;

        const paymentdetail = document.getElementById('paymentdetail').value;
        const approved_payment_amt = document.getElementById('approvedamt').value;
        const paymentamt = document.getElementById('paymentamt').value;
        const paymentdate = document.getElementById('paymentdate').value;
        const remark = document.getElementById('remark').value;
        const sno = localStorage.getItem('vendorpaymentssno');
        const org = localStorage.getItem('Database');

        if (!paymentdetail || !paymentamt || !paymentdate) {
            setLoading(true);
            document.getElementById('subnitbtn').disabled = false;
            callfun('Please enter the Mandatory Field', 'warning', 'self');
            return;
        } else {
            const result = await UpdateVendorPayment(
                org,
                paymentdetail,
                paymentamt,
                paymentdate,
                remark,
                sno,
                filedata,
                approved_payment_amt
            );
            setLoading(true);

            if (result === 'Data Updated') {
                localStorage.removeItem('vendorpaymentssno');
                callfun('Vendor Payment Updated', 'success', '/TotalVendorPayment');
            } else {
                callfun('Server Error', 'danger', 'self');
                document.getElementById('subnitbtn').disabled = false;
            }
        }
    };

    const handleFileUpload = async (event) => {
        if (!vendor) {
            callfun('Select vendor first.', 'danger', 'self');
            return;
        }
        setFileLoading(true);
        setFileUploadedSuccess(false);

        try {
            const file = event.target.files[0];
            if (!file) {
                callfun('No file selected', 'warning', 'self');
                return;
            }

            if (file.size > 5 * 1024 * 1024) {
                callfun('File size exceeds 5MB', 'warning', 'self');
                return;
            }

            const data = new FormData();
            data.append('files', file);
            data.append('fileType', 'CHQ');
            data.append('vendorName', vendor);

            const response = await FileUpload(data);

            if (response && response.uploaded && response.uploaded.length > 0) {
                const uploadedUrl = response.uploaded[0];
                setFiledata(uploadedUrl);
                callfun('File uploaded successfully', 'success', 'self');
                setFileUploadedSuccess(true);
            } else {
                callfun('File upload failed: Invalid response', 'danger', 'self');
            }
        } catch (err) {
            callfun(`Error uploading file: ${err.message}`, 'danger', 'self');
        } finally {
            setFileLoading(false);
        }
    };

    return (
        <>
            {loading ? (
                <Sidebar>
                    <Modal
                        theme={tooglevalue.theme}
                        text={tooglevalue.message}
                        show={tooglevalue.modalshowval}
                        url={tooglevalue.url}
                    />

                    <div className="main_container">
                        <div className="main-inner-container d-flex justify-content-between pt-4 pb-3">
                            <h4>
                                <span className="page-type-head1">Vendor Payment <MdOutlineKeyboardArrowRight /></span>
                                <span className="page-type-head2">Edit Vendor Payment</span>
                            </h4>
                            <button
                                className="btn btn-secondary"
                                onClick={() => {
                                    localStorage.removeItem('vendorpaymentssno');
                                    window.location.href = '/TotalVendorPayment';
                                }}
                            >
                                Back <RiArrowGoBackFill />
                            </button>
                        </div>

                        <div className="bg-white shadow1-silver rounded15 mt-1 card inner-card pt-2">
                            <article className="card-body">
                                <form className="px-3" autoComplete="off">
                                    <div className="row">
                                        <div className="form-group col-md-4">
                                            <label htmlFor="invno">Invoice no <span className="text-danger">*</span></label>
                                            <select className="form-select" disabled>
                                                <option hidden>{`${data.reference_no}, (${data.invoice_no})`}</option>
                                                {pendinginvoicelist.map((item, index) => (
                                                    <option key={index} value={`${item.sno},${item.invoice_amt}`}>
                                                        {`${item.reference_no}, (${item.invoice_no})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label htmlFor="accountno">Account no <span className="text-danger">*</span></label>
                                            <input type="text" id="accountno" className="form-control" disabled defaultValue={data.account_no} />
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label htmlFor="paymentdetail">Payment Details <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" id="paymentdetail" defaultValue={data.payment_detail} />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="form-group col-md-4">
                                            <label htmlFor="approvedamt">Approved Amount</label>
                                            <input type="number" id="approvedamt" className="form-control" defaultValue={data.approved_payment_amt} />
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label htmlFor="paymentamt">Payment Amount <span className="text-danger">*</span></label>
                                            <input type="number" id="paymentamt" className="form-control" defaultValue={data.payment_amt} />
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label htmlFor="paymentdate">Payment date <span className="text-danger">*</span></label>
                                            <input type="date" id="paymentdate" className="form-control" defaultValue={data.PaymentDate} />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="form-group col-md-4">
                                            <label htmlFor="refno">Reference No <span className="text-danger">*</span></label>
                                            <input type="text" id="refno" className="form-control" defaultValue={data.reference_no} disabled />
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label htmlFor="remark">Remarks</label>
                                            <textarea className="form-control" id="remark" rows="3" defaultValue={data.payment_remark}></textarea>
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label>Uploaded Document</label>
                                            {filedata ? (
                                                <>
                                                    <iframe src={filedata} style={{ height: '250px', width: '100%' }} title="Document Preview" />
                                                </>
                                            ) : null}
                                            <input type="file" onChange={handleFileUpload} className="form-control mt-2" />
                                            {fileLoading && <small>Uploading...</small>}
                                        </div>
                                    </div>
                                </form>
                            </article>

                            <div className="btn_div mt-3 card-footer">
                                <button className="btn btn-voilet" id="subnitbtn" onClick={handleAddVendorIvoice}>
                                    Update Vendor Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </Sidebar>
            ) : (
                <LoadingPage />
            )}
        </>
    );
}

export default EditVendorPayments;
